import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger )

function initTextWithImage() {
	if( window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
		return;
	}

	let components = document.querySelectorAll( '.c-text-with-image' );

	components.forEach( component => {
		initMediaAnimations( component );
		initContentAnimations( component );
	});
}

function initMediaAnimations( component ) {
	let media = component.querySelector( '.c-text-with-image_media' );

	gsap.set( media, { translateX: '50%' } );

	gsap.timeline({
		scrollTrigger: {
			trigger: component,
			scrub: 1,
			start: 'top-=100px bottom',
			end: 'bottom+=100px top'
		}
	})
	.to( media, { 
		keyframes: [
			{ duration: 1, translateX: '0%' },
			{ duration: 1, translateX: '50%' }
		]
	});
}

function initContentAnimations( component ) {
	let content = component.querySelector( '.c-text-with-image_content' );

	gsap.set( content, { translateX: '-50%' } );

	gsap.timeline({
		scrollTrigger: {
			trigger: component,
			scrub: 1,
			start: 'top-=100px bottom',
			end: 'bottom+=100px top'
		}
	})
	.to( content, { 
		keyframes: [
			{ duration: 1, translateX: '0%' },
			{ duration: 1, translateX: '-50%' }
		]
	});
}

export {initTextWithImage};